"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var checkboxBottomMargin = 2;
var comboBottomMargin = 1;
var cmpWidth = 360;
var labelWidth = 125;
var numberWidth = 80;
var numberHeight = 18;

exports.default = {
    checkboxBottomMargin: checkboxBottomMargin,
    comboBottomMargin: comboBottomMargin,
    cmpWidth: cmpWidth,
    labelWidth: labelWidth,
    numberWidth: numberWidth,
    numberHeight: numberHeight
};
//# sourceMappingURL=Style.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/Style.js
 ** module id = 12
 ** module chunks = 0
 **/